import React from 'react';
import { AchievementsPage } from '../AchievementsPage';

export function AchievementsManagementPage() {
  return <AchievementsPage />;
}